// The chosen values a choice block prints in the note's document, and the
// way to the block's options after them, as the document's tools find them.

export const listChosenValueNodes = (within: ParentNode, blockId: string) =>
  [...within.querySelectorAll<HTMLElement>('[data-note-choice-value]')].filter(
    (node) => node.dataset.noteBlockId === blockId,
  );

export const lastChosenValueNode = (trigger: HTMLElement, blockId: string) =>
  listChosenValueNodes(
    trigger.closest('[data-lexical-editor]') ?? document,
    blockId,
  ).at(-1) ?? null;

const findChosenValueOptions = (root: HTMLElement, blockId: string) =>
  [...root.querySelectorAll<HTMLElement>('[data-note-block-aside]')]
    .find((node) => node.dataset.noteBlockAside === blockId)
    ?.querySelector<HTMLElement>(
      '[data-component="workspace-note-choice-text"]',
    ) ?? null;

export const focusChosenValueOptions = (root: HTMLElement, blockId: string) =>
  findChosenValueOptions(root, blockId)?.focus();

// The chosen value a click opens its block's options from, while the click
// is handed to the way to them.
const valueOpens = new Map<string, HTMLElement>();

export const readChosenValueOpen = (blockId: string) =>
  valueOpens.get(blockId) ?? null;

// A chosen value clicked in the note's document opens the options of its
// block under it, and the caret stays where the click put it, so the value
// can still be typed over.
export const openChosenValueOptions = (
  root: HTMLElement,
  blockId: string,
  value: HTMLElement,
) => {
  const trigger = findChosenValueOptions(root, blockId);
  if (!trigger || trigger.dataset.state === 'open') {
    return;
  }
  valueOpens.set(blockId, value);
  trigger.click();
  valueOpens.delete(blockId);
};
